<template>
  <div
    class="buildup sticky-ui-wrapper"
    @mousemove="moveLayer"
    @mouseleave="stopLayerMove">
    <div
      v-if="editView === 'fluids'"
      class="buildup-ui sticky-ui is-visible">
      <toggle-switch
        v-model="useCoverIngredient"
        style="margin-right: 1rem;">
        Dodaj składnik wierzchni
      </toggle-switch>

      <toggle-switch v-model="useToppingIngredient">
        Dodaj ozdoby
      </toggle-switch>
    </div>

    <div
      v-if="editView === 'texts' || editView === 'addons' || editView === 'steps'"
      class="buildup-ui sticky-ui is-visible">
      <toggle-switch v-model="showBlockFrames">
        Pokaż ramki elementów
      </toggle-switch>

      <small
        v-if="editView === 'texts'"
        class="buildup-text-layers-notice">
        Aby przenosić warstwy tekstowe kliknij dwukrotnie na tekście, który chcesz przenieść.
      </small>

      <small
        v-if="editView === 'addons'"
        class="buildup-text-layers-notice">
        Aby przenosić dodatki kliknij dwukrotnie na dodatku, który chcesz przenieść.
      </small>
    </div>

    <div
      ref="buildup"
      class="buildup-area mb-3"
      :style="'height:' + (((fluidParams.height * 1) + (fluidParams.padding * 2)) + (toppingHeight * 1) + (coverHeight * 1)) + 'px;'">
      <div
        :class="{
          'buildup-area-content': true,
          'has-topping-ingredient': useToppingIngredient,
          'has-cover-ingredient': useCoverIngredient,
          'is-showing-frames': showBlockFrames,
          'has-selected-block': !!selectedBlock
        }">
        <div
          v-if="useToppingIngredient && (toppingIngredientSafe[0].ingredient_id || toppingIngredientSafe[1].ingredient_id)"
          class="buildup-area-content-topping">
          <img
            v-if="toppingIngredientSafe[0].ingredient_id"
            :src="getIngredientImage(toppingIngredientSafe[0].ingredient_id)"
            alt="" />

          <img
            v-if="toppingIngredientSafe[1].ingredient_id"
            :src="getIngredientImage(toppingIngredientSafe[1].ingredient_id)"
            alt="" />
        </div>

        <div
          v-if="useCoverIngredient && coverIngredientSafe.ingredient_id"
          class="buildup-area-content-cover">
          <img
              :src="getIngredientImage(coverIngredientSafe.ingredient_id)"
              alt="" />
        </div>

        <template v-for="(fluid, index) of orderedFluids" :key="'fluid-' + index">
          <div
            :data-id="fluid.id"
            :class="{
              'buildup-area-content-fluid': true,
              'is-selected': editView === 'fluids' && fluid.id === selectedBlock
            }"
            :style="'top: ; z-index: ' + index + ';'">
            <fluid
              :color="getFluidColor(fluid.ingredient_id)"
              :maxHeight="fluidParams.height"
              :bottom="fluidParams.height * getFluidBottom(index)"
              :height="fluidParams.height * (fluid.quantity / 100)"
              :width="fluidParams.width"
              :padding="fluidParams.padding"
              :diffTopBottom="fluidParams.diffTopBottom" />
          </div>
        </template>

        <div
          v-if="extendedAddons.length"
          class="buildup-area-content-addons"
          ref="buildup-addons">
          <template v-for="(addon, index) of extendedAddons" :key="'addon-' + index">
            <div
              :data-id="addon.id"
              :class="{
                'buildup-area-content-addon': true,
                'is-inactive': !!movedAddon && movedAddon.itemID !== addon.id,
                'is-not-moveable': editView !== 'addons',
                'is-selected': editView === 'addons' && addon.id === selectedBlock
              }"
              :style="{
                'left': addon.position ? addon.position.x + 'px' : '',
                'top': addon.position ? addon.position.y + 'px' : '',
                'width' : addon.width + 'px',
                'height': addon.height + 'px'
              }"
              @dblclick="selectLayer(addon.id)"
              @mousedown="startAddonMove(addon.id)"
              @mouseup="stopAddonMove"
              @mouseleave="stopAddonMove">
              <img
                :src="addon.image_url"
                :width="addon.width"
                :height="addon.height"
                alt="" />
            </div>
          </template>
        </div>

        <template v-for="(layer, index) of layers" :key="'layer-' + index">
          <div
            :data-id="layer.id"
            :class="{
              'buildup-area-content-text-layer': true,
              'is-inactive': !!movedLayer && movedLayer.itemID !== layer.id,
              'is-not-moveable': editView !== 'texts',
              'is-selected': editView === 'texts' && layer.id === selectedBlock
            }"
            :style="'left: ' + layer.position.x + 'px; top: ' + (layer.position.y + layerTopOffset) + 'px; font-size: ' + (layer.fontSize ? layer.fontSize + 'px' : '24px') + '; color: ' + (layer.textColor === 'light' ? '#fff' : '#222') + ''"
            :data-text-align="layer.textAlign"
            @dblclick="selectLayer(layer.id)"
            @mousedown="startLayerMove(layer.id)"
            @mouseup="stopLayerMove"
            @mouseleave="stopLayerMove">
            <span>{{ layer.text }}</span>
          </div>
        </template>

        <div class="buildup-area-content-glass" v-if="!(useCoverIngredient && coverIngredientSafe)">
          <svg width="506px" height="1000px" viewBox="0 0 506 1000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <ellipse id="Oval" stroke="#000000" stroke-width="4" cx="252" cy="104" rx="250" ry="100"></ellipse>
              <path d="M452,994 C452,949.81722 362.45695,914 252,914 C141.54305,914 52,949.81722 52,994" id="Oval" stroke="#000000" stroke-width="4" transform="translate(252.000000, 954.000000) scale(1, -1) translate(-252.000000, -954.000000) "></path>
              <line x1="2" y1="106.5" x2="52" y2="914" id="Line" stroke="#000000" stroke-width="4" stroke-linecap="square"></line>
              <line x1="452" y1="106.5" x2="502" y2="914" id="Line" stroke="#000000" stroke-width="4" stroke-linecap="square" transform="translate(477.000000, 510.250000) scale(-1, 1) translate(-477.000000, -510.250000) "></line>
            </g>
          </svg>
        </div>

        <div class="buildup-area-content-glass buildup-area-content-glass-top" v-if="(useCoverIngredient && coverIngredientSafe)">
          <svg width="506px" height="1000px" viewBox="0 0 506 1000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="glass-top-part" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <path d="M502,104 C502,48.771525 390.071187,4 252,4 C113.928813,4 2,48.771525 2,104" id="Oval" stroke="#000000" stroke-width="4"></path>
              </g>
          </svg>
        </div>

        <div class="buildup-area-content-glass" v-if="(useCoverIngredient && coverIngredientSafe)">
          <svg width="506px" height="1000px" viewBox="0 0 506 1000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M502,203 C502,147.771525 390.071187,103 252,103 C113.928813,103 2,147.771525 2,203" id="Oval" stroke="#000000" stroke-width="4" transform="translate(252.000000, 153.000000) scale(1, -1) translate(-252.000000, -153.000000) "></path>
              <path d="M452,994 C452,949.81722 362.45695,914 252,914 C141.54305,914 52,949.81722 52,994" id="Oval" stroke="#000000" stroke-width="4" transform="translate(252.000000, 954.000000) scale(1, -1) translate(-252.000000, -954.000000) "></path>
              <line x1="2" y1="106.5" x2="52" y2="914" id="Line" stroke="#000000" stroke-width="4" stroke-linecap="square"></line>
              <line x1="452" y1="106.5" x2="502" y2="914" id="Line" stroke="#000000" stroke-width="4" stroke-linecap="square" transform="translate(477.000000, 510.250000) scale(-1, 1) translate(-477.000000, -510.250000) "></line>
            </g>
          </svg>
        </div>
      </div>
    </div>

    <div class="buildup-footer pt-3">
      <d-input
        class="w-25 ml-auto mr-auto text-center"
        placeholder="Rozmiar"
        :value="drinkSize"
        @input="updateSize" />
    </div>
  </div>
</template>

<script>
import Fluid from './Fluid.vue';
import ToggleSwitch from './../common/ToggleSwitch.vue';

export default {
  name: 'buildup-drinks',
  props: {
    addons: { type: Array, default: () => [] },
    fluids: { type: Array, default: () => [] },
    drinkSize: { type: [String, Number], default: '' },
    editView: { type: String, default: '' },
    ingredientsData: { type: Array, default: () => [] },
    ingredientsAddonsData: { type: Array, default: () => [] },
    layers: { type: Array, default: () => [] },
    selectedBlock: { type: [String, Number, Boolean], default: null },
    fluidParams: {
      type: Object,
      default: () => ({
        height: 0,
        padding: 0,
        width: 0,
        diffTopBottom: 0
      })
    },
    toppingIngredient: { type: [Array, Object], default: () => [{}, {}] },
    coverIngredient: { type: Object, default: () => ({}) },
    usesCoverIngredient: { type: Boolean, default: false },
    usesToppingIngredient: { type: Boolean, default: false }
  },
  components: {
    'fluid': Fluid,
    'toggle-switch': ToggleSwitch
  },
  computed: {
    toppingIngredientSafe () {
      if (Array.isArray(this.toppingIngredient)) {
        const first = this.toppingIngredient[0];
        const second = this.toppingIngredient[1];

        return [
          first && typeof first === 'object' ? first : {},
          second && typeof second === 'object' ? second : {}
        ];
      }

      return [{}, {}];
    },
    coverIngredientSafe () {
      return this.coverIngredient && typeof this.coverIngredient === 'object' ? this.coverIngredient : {};
    },
    layersSafe () {
      return Array.isArray(this.layers) ? this.layers.filter(Boolean) : [];
    },
    addonsSafe () {
      return Array.isArray(this.addons) ? this.addons.filter(Boolean) : [];
    },
    ingredientsDataSafe () {
      return Array.isArray(this.ingredientsData) ? this.ingredientsData.filter(Boolean) : [];
    },
    ingredientsAddonsDataSafe () {
      return Array.isArray(this.ingredientsAddonsData) ? this.ingredientsAddonsData.filter(Boolean) : [];
    },
    coverHeight () {
      if (this.useCoverIngredient) {
        return 200;
      }

      return 0;
    },
    toppingHeight () {
      if (this.useToppingIngredient) {
        return 200;
      }

      return 0;
    },
    layerTopOffset () {
      // Check if layer positions already include offset (old data with maxY > 500)
      const maxY = this.layersSafe.reduce((max, layer) => {
        return layer.position && layer.position.y > max ? layer.position.y : max;
      }, 0);
      
      // Base glass height is ~500px, if positions exceed this, they already include offset
      if (maxY > 500) {
        return 0;
      }
      
      return this.coverHeight + this.toppingHeight + 0;
    },
    orderedFluids () {
      const fluids = Array.isArray(this.fluids) ? this.fluids.filter(Boolean) : [];
      return fluids.slice(0).reverse();
    },
    extendedAddons () {
      let addons = this.addonsSafe.slice(0);

      for (let i = 0; i < addons.length; i++) {
        if (addons[i].ingredient_id) {
          let foundedIngredient = this.ingredientsAddonsDataSafe.filter(ingredient => ingredient.id === parseInt(addons[i].ingredient_id, 10));

          if (foundedIngredient.length) {
            addons[i].width = parseInt(foundedIngredient[0].image_size.width, 10);
            addons[i].height = parseInt(foundedIngredient[0].image_size.height, 10);
            addons[i].image_url = foundedIngredient[0].image_url;
          }
        }
      }

      addons.reverse();
      return addons;
    }
  },
  data () {
    return {
      useCoverIngredient: false,
      useToppingIngredient: false,
      movedLayer: false,
      movedAddon: false,
      showBlockFrames: false
    };
  },
  watch: {
    useCoverIngredient (newValue, oldValue) {
      if (!newValue && newValue !== oldValue) {
        this.$bus.emit('buildup-reset-cover-ingredient');
      } else if (newValue !== oldValue) {
        this.$bus.emit('buildup-set-cover-ingredient');
      }
    },
    useToppingIngredient (newValue, oldValue) {
      if (!newValue && newValue !== oldValue) {
        this.$bus.emit('buildup-reset-topping-ingredient');
      } else if (newValue !== oldValue) {
        this.$bus.emit('buildup-set-topping-ingredient');
      }
    }
  },
  mounted () {
    this.useCoverIngredient = !!this.usesCoverIngredient;
    this.useToppingIngredient = !!this.usesToppingIngredient;
  },
  methods: {
    getFluidColor (ingredientID) {
      if (!ingredientID) {
        return '#ffffff';
      }

      let foundedIngredients = this.ingredientsDataSafe.filter(ingredient => ingredient.id === ingredientID);

      if (foundedIngredients.length) {
        return foundedIngredients[0].color;
      }

      return '#ffffff';
    },
    getFluidBottom (index) {
      let bottom = 0;

      for (let i = 0; i < index; i++) {
        const quantity = this.orderedFluids[i] && this.orderedFluids[i].quantity ? this.orderedFluids[i].quantity : 0;
        bottom += parseInt(quantity, 10) || 0;
      }

      return bottom / 100;
    },
    moveLayer (e) {
      if (!this.movedLayer && !this.movedAddon) {
        return;
      }

      if (this.movedLayer) {
        let x = e.pageX - this.$refs['buildup'].getBoundingClientRect().left;
        let y = e.pageY - ((this.$refs['buildup'].getBoundingClientRect().top + window.pageYOffset)) - this.layerTopOffset;
        this.$bus.emit('buildup-layer-move', this.movedLayer, x, y);
      } else if (this.movedAddon) {
        let x = e.pageX - this.$refs['buildup-addons'].getBoundingClientRect().left;
        let y = e.pageY - ((this.$refs['buildup-addons'].getBoundingClientRect().top + window.pageYOffset));
        this.$bus.emit('buildup-addon-move', this.movedAddon, x, y);
      }
    },
    startLayerMove (itemID) {
      if (this.selectedBlock !== itemID) {
        this.movedLayer = false;
        return;
      }

      this.movedLayer = {
        itemID
      };
    },
    stopLayerMove () {
      this.movedLayer = false;
    },
    selectLayer (itemID) {
      this.$bus.emit('buildup-layer-select', itemID);
    },
    startAddonMove (itemID) {
      if (this.selectedBlock !== itemID) {
        this.movedAddon = false;
        return;
      }

      this.movedAddon = {
        itemID
      };
    },
    stopAddonMove () {
      this.movedAddon = false;
    },
    removeBlock (index) {
      this.data.blocks.splice(index, 1);
    },
    getIngredientImage (ingredientID) {
      let foundedIngredient = this.ingredientsData.filter(ingredient => ingredient.id === ingredientID);

      if (foundedIngredient && foundedIngredient[0]) {
        return foundedIngredient[0].image_url;
      }

      return null;
    },
    getSvgCode (fluidID) {
      let svg = document.querySelector('.buildup-area-content-fluid[data-id="' + fluidID + '"] svg');

      if (svg) {
        return svg.outerHTML;
      }

      return '';
    },
    updateSize (value) {
      this.$bus.emit('buildup-update-drink-size', value);
    }
  }
}
</script>

<style lang="scss" scoped>
$glassBackZindex: 25;
$coverZIndex: 26;
$addonsZindex: 30;
$glassFrontZindex: 99;
$textZIndex: 100;

.buildup {
  margin: 0 auto 50px auto;
  position: relative;
  user-select: none;

  &-footer {
    display: flex;
    justify-content: center;
  }

  &-ui {
    align-items: center;
    display: flex;
    height: 50px;
    justify-content: center;
    margin-bottom: 30px;
    opacity: 0;
    position: absolute;
    top: 10px;
    width: 100%;

    .buildup-text-layers-notice {
      bottom: 0px;
      left: 50%;
      position: absolute;
      text-align: center;
      transform: translateX(-50%);
      width: 100%;
    }

    &.is-visible {
      opacity: 1;
    }
  }

  &-area {
    margin: 0 auto;
    position: relative;
    width: 100%;

    &-content {
      height: 100%;
      width: 100%;
      z-index: 1;

      &-cover,
      &-topping {
        align-items: flex-end;
        display: flex;
        height: 200px;
        position: absolute;
        width: 100%;

        img {
          display: block;
          margin: 0 auto;
          max-height: 100%;
          max-width: 100%;
        }
      }

      &-cover {
        top: 85px;
        z-index: $coverZIndex;

        img {
          height: auto;
          width: 290px;
        }
      }

      &-topping {
        height: 200px;
      }

      &.has-topping-ingredient {
        padding-top: 200px;

        .buildup-area-content-topping {
          top: 0;
        }
      }

      &.has-cover-ingredient {
        padding-top: 200px;

        .buildup-area-content-cover {
          top: 85px;
        }

        &.has-topping-ingredient {
          padding-top: 400px;

          .buildup-area-content-cover {
            top: 285px;
          }

          .buildup-area-content-topping {
            top: 0;
          }
        }
      }

      &-addons {
        height: 500px;
        margin: 0 auto;
        position: relative;
        width: 250px;
        z-index: $addonsZindex;
      }

      &-addon {
        border: 2px dashed transparent;
        border-radius: 10px;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
        z-index: $addonsZindex;

        img {
          pointer-events: none;
        }
      }

      &-text-layer {
        border: 2px dashed transparent;
        border-radius: 10px;
        font-size: 24px;
        font-weight: bold;
        line-height: 46px;
        min-height: 50px;
        padding: 0 20px;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
        width: 800px;
        z-index: $textZIndex;

        & > span {
          user-select: none;
        }

        &[data-text-align="left"] {
          text-align: left;
        }

        &[data-text-align="center"] {
          text-align: center;
        }

        &[data-text-align="right"] {
          text-align: right;
        }

        &.is-not-moveable {
          pointer-events: none;
        }
      }

      &-fluid {
        border: none;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
        width: 100%;
      }

      &-glass {
        bottom: 4px;
        height: 500px;
        left: 50%;
        margin-left: -140px;
        pointer-events: none;
        position: absolute;
        width: 280px;
        z-index: $glassFrontZindex;

        svg {
          height: 100%;
          position: absolute;
          width: 100%;
        }

        &-top {
          z-index: $glassBackZindex;
        }
      }

      .buildup-area-content-addon,
      .buildup-area-content-text-layer {
        &.is-selected {
          background: rgba(255, 244, 222, .33);
          border-color: #eedda9;
        }
      }

      .buildup-area-content-addon {
        &.is-selected {
          cursor: move;
        }
      }
      .buildup-area-content-text-layer {
        &.is-selected {
          cursor: move;
          z-index: 999;
        }
      }

      &.is-showing-frames {
        .buildup-area-content-addon,
        .buildup-area-content-text-layer {
          border-color: #aaa;

          &.is-selected {
            border-color: #eedda9;
          }
        }
      }

      &.has-selected-block {
        .buildup-area-content-fluid {
          opacity: .33;

          &.is-selected {
            opacity: 1;
          }
        }

        .buildup-area-content-addon {
          opacity: .5;
          pointer-events: none;

          &.is-selected {
            opacity: 1;
            pointer-events: auto;
          }
        }
      }
    }
  }
}

.sticky-ui-wrapper {
  position: relative;

  .sticky-ui {
    background: #f5f6f8;
    box-shadow: 0 0 30px #f5f6f8, 0 0 25px #f5f6f8, 0 0 20px #f5f6f8, 0 0 15px #f5f6f8, 0 0 10px #f5f6f8;
    left: 0;
    margin-left: -10px;
    margin-right: -10px;
    position: sticky;
    top: 0;
    width: calc(100% + 20px);
    z-index: 1000;
  }
}
</style>
